module.exports = __webpack_public_path__ + "static/media/postevita.1b427070.svg";